
import "./Statistica.css";
import React, { useEffect, useState } from "react";
import { Cell, Legend, Pie, PieChart, Tooltip } from "recharts";

const COLORS = ["#F5D493", "#A6A6F5", "#A6E8F5", "#CEF5A6", "#F5B1A6"];

const  CustomTooltip = ({ payload, allCount } : { payload: any, allCount: number }) => {
    if (payload) {
        return (
            <div
                className = "custom-tooltip"
                style = {{
                    width: "auto",
                    height: "60px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#ffff",
                    padding: "5px 10px",
                    boxShadow: "0 0 5px rgba(0,0,0,0.5)",
                    borderRadius: "7px"
                }}
            >
                <label className = "circleChartValueText">{ `${payload[0]?.name}` }</label>
                <label className = "circleChartValueText">{` ${payload[0]?.value}  (${Math.round(payload[0]?.value / allCount * 100)}%)`}</label>
            </div>
        );
    }
    return null;
};

export type business = {
    id: string
    key: string,
    clients?: Array<any>,
    value: number
}

function BusinessTypeChart({ businessTypes, showDate } : { businessTypes: any, showDate: string[]} ) {

    const [pieData, setPieData] = useState<Array<business>>([
        {
            id: "Real Estate",
            key: "Real Estate",
            value: 0
        },
        {
            id: "Insurance",
            key: "Insurance",
            value: 0
        },
        {
            id: "Investment",
            key: "Investment",
            value: 0
        },
        {
            id: "Mortgage",
            key: "Mortgage",
            value: 0
        },
        {
            id: "Other Type",
            key: "Other Type",
            value: 0
        }
    ]);
    const [allCount, setAllCount] = useState<number>(0);

    useEffect(() => {
        setPieData(
            [
                {
                    id: "Real Estate",
                    key: "Real Estate",
                    value: 0
                },
                {
                    id: "Insurance",
                    key: "Insurance",
                    value: 0
                },
                {
                    id: "Investment",
                    key: "Investment",
                    value: 0
                },
                {
                    id: "Mortgage",
                    key: "Mortgage",
                    value: 0
                },
                {
                    id: "Other Type",
                    key: "Other Type",
                    value: 0
                }
            ]
        )
        if (businessTypes) {
            let businessData = new Array();
            for (let key in businessTypes) {
                const findDay = showDate.find((date: string) => date === key);
                if (findDay) {
                    businessTypes[key].forEach((item: any) => businessData.push(item));
                }
            }

            if (businessData.length > 0) {
                businessData.forEach(item => {
                    if (item.key === "Real Estate" || item.key === "Mortgage" || item.key === "Investment" || item.key === "Insurance") {
                        setPieData(pieData => pieData.map(pie => pie.id === item.key ? {
                            ...pie,
                            value: pie.value + item.value
                        } : {...pie}))
                    }
                    else {
                        setPieData(pieData => pieData.map(pie => pie.id === "Other Type" ? {
                            ...pie,
                            value: pie.value + item.value
                        } : {...pie}))
                    }
                })
            }
        }
    }, [businessTypes, showDate]);

    useEffect(() => {
        const allAddClients: number = pieData.reduce((count: number, elem: business) => count += elem.value, 0);
        setAllCount(allAddClients);
    }, [pieData]);

    return(
        <div className = "BusinessTypeChart">
            <div className = "piechart-header-box">
                Business Type
            </div>
            <PieChart
                width = { window.innerWidth > 500 ? 350 : 250 }
                height = { window.innerWidth > 500 ? 350 : 250 }
            >
                <Pie
                    data = { pieData }
                    labelLine = { false }
                    color = "#000000"
                    dataKey = "value"
                    nameKey = "key"
                    cx = "50%"
                    cy = "50%"
                    outerRadius = { window.innerWidth > 500 ? 150 : 100 }
                    fill = "#8884d8"
                >
                    {
                        pieData.map((entry, index) => {
                            return(
                                <Cell
                                    style = {{ outline: "none" }}
                                    key = {`cell-${index}`}
                                    fill = {
                                        COLORS[index % COLORS.length]
                                    }
                                />
                            )
                        })
                    }
                </Pie>
                <Tooltip content = { <CustomTooltip payload = { pieData } allCount = { allCount }/> }/>
                <Legend
                    width = { 400 }
                    layout = { "vertical" }
                    align = "center"
                    payload = {
                        pieData.map(
                            (item, index) => ({
                                id: item.id,
                                value: `${item.key} (${item.value})`,
                                color: COLORS[index % COLORS.length]
                            })
                        )
                    }
                />
            </PieChart>
        </div>
    )
}

export default BusinessTypeChart